import React, { useContext } from 'react';
import cx from 'classnames';
import styled from '@emotion/styled';
import { ButtonGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { assetUrl } from '~/helpers';
import { palette } from '~/utils/colours';
import Button from '~/App/Components/Button';
import EditorContext from '../Pages/Editor/Context';

const ToggleListIcon = styled.div`
  width: 35px;
  height: 35px;
  margin: auto;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-image: url(${({ icon }: { icon: string }) => assetUrl(icon)});
`;

const StyledLink = styled(Link)`
  padding: 10px;
  :hover {
    color: ${palette.tealishTwo} !important;
    ${ToggleListIcon} {
      background-color: ${palette.tealishTwo} !important;
    }
  }
  &:not(.active) {
    color: ${palette.brownGrey};
    ${ToggleListIcon} {
      background-color: ${palette.brownGrey};
    }
  }
  &.active {
    ${ToggleListIcon} {
      background-color: ${palette.tealishTwo};
    }
  }
  div {
    font-size: 12px;
    line-height: normal;
    letter-spacing: 0.08px;
  }
`;

const StyledButtonGroup = styled(ButtonGroup)`
  position: relative;
  margin-top: 5px;
  display: flex;
  justify-content: center;

  @media (max-width: 640px) {
    flex-wrap: wrap;
    margin-bottom: 10px;
  }
`;

const StyledPreviewBtn = styled(Button)`
  position: absolute !important;
  top: 15px;
  right: 5%;
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;

  @media (max-width: 640px) {
    position: relative !important;
    top: unset;
    right: unset;
    width: 100%;
  }
`;

interface ToggleListProps {
  options: Array<{
    icon: string;
    label: string;
    url: string;
    isActive: boolean;
  }>;
  showPreviewBtn?: boolean;
}

export default function ToggleList({
  options,
  showPreviewBtn = false,
}: ToggleListProps) {
  const context = useContext(EditorContext);
  const { hasChanges } = context;

  return (
    <StyledButtonGroup>
      {options.map(({ url, isActive, label, icon }, key) => {
        return (
          <StyledLink to={url} className={cx({ active: isActive })} key={key}>
            <ToggleListIcon icon={icon} />
            <div>{label}</div>
          </StyledLink>
        );
      })}
      {showPreviewBtn && (
        <StyledPreviewBtn
          onClick={() =>
            window.open(`/message-template/${context.get('id')}/preview`)
          }
          disabled={!!hasChanges}
        >
          Preview message
        </StyledPreviewBtn>
      )}
    </StyledButtonGroup>
  );
}
